import React from 'react';
import {Heading, Box, Text} from 'native-base';
import {message} from '../../../../../../../utils/messages';
import {SearchInput} from '../../../../../../../components/inputs';

interface HeaderProps {
  count: number;
  onChangeSearch?: (value: string) => void;
  searchText: string;
}

const HeaderBox = (props: HeaderProps) => {
  const {count, onChangeSearch, searchText} = props;

  const getLabelResultLength = () => {
    if (count === 1) {
      return `${count}  ${message('balance-list-search-count-title-table')}`;
    }

    return `${count}  ${message(
      'balance-list-search-count-plural-title-table',
    )}`;
  };

  const SearchSummary = () => {
    if (searchText === '') {
      return (
        <Heading
          color="#06355E"
          fontSize="md"
          fontWeight="medium"
          marginBottom={5}>
          {message('client-list-title-table')}
        </Heading>
      );
    }
    return (
      <Box marginBottom={5}>
        <Heading color="#06355E" fontSize="md" fontWeight="medium">
          {message('balance-list-search-title-table')}
        </Heading>
        <Text color="#858597">{getLabelResultLength()}</Text>
      </Box>
    );
  };

  return (
    <>
      <Box
        paddingBottom={0}
        borderBottomColor="blue.200"
        borderBottomWidth={1}
        marginBottom={5}>
        <Heading
          color="#06355E"
          fontSize="md"
          fontWeight="medium"
          marginBottom={5}>
          {message('balance-list-title-search')}
        </Heading>
        <SearchInput onChange={onChangeSearch} />
      </Box>
      <SearchSummary />
    </>
  );
};

export default HeaderBox;
